import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import "./assets/css/base.css";
import "./assets/css/normalize.css"
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import i18n from "../src/langue/i18n.js"
Vue.config.productionTip = true
Vue.use(ElementUI);

new Vue({
  
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')
